var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.999878,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.999878,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#ECE9E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2281 12.8395C16.9263 11.5378 14.8158 11.5378 13.514 12.8395L13.0677 13.2858C12.4524 13.9011 12.0316 14.8231 12.2716 15.822C12.6396 17.3532 13.747 20.1436 17.0495 23.4461C20.352 26.7486 23.1424 27.856 24.6737 28.224C25.6725 28.4641 26.5946 28.0432 27.2099 27.4279L27.6561 26.9816C28.9579 25.6799 28.9579 23.5693 27.6561 22.2676L26.8821 21.4935C25.821 20.4325 24.1818 20.2112 22.8774 20.9529L22.7969 20.9987C22.2624 21.3026 21.6483 21.2778 21.2133 20.9629C20.8623 20.7089 20.5268 20.4415 20.2904 20.2052C20.0541 19.9688 19.7868 19.6334 19.5327 19.2823C19.2179 18.8473 19.193 18.2332 19.497 17.6987L19.5427 17.6183C20.2845 16.3138 20.0632 14.6746 19.0021 13.6136L18.2281 12.8395ZM14.6925 14.018C15.3434 13.3671 16.3987 13.3671 17.0495 14.018L17.8236 14.7921C18.3541 15.3226 18.4648 16.1422 18.0939 16.7944L18.0482 16.8749C17.4608 17.9079 17.4401 19.2336 18.1825 20.2595C18.4552 20.6363 18.7829 21.0547 19.1119 21.3837C19.4409 21.7127 19.8594 22.0404 20.2362 22.3131C21.262 23.0555 22.5877 23.0349 23.6208 22.4475L23.7012 22.4017C24.3534 22.0309 25.173 22.1415 25.7036 22.672L26.4776 23.4461C27.1285 24.097 27.1285 25.1523 26.4776 25.8031L26.0314 26.2494C25.709 26.5718 25.3537 26.6733 25.0631 26.6035C23.8389 26.3093 21.3194 25.359 18.2281 22.2676C15.1367 19.1762 14.1864 16.6567 13.8921 15.4325C13.8223 15.142 13.9239 14.7867 14.2462 14.4643L14.6925 14.018Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhone);
export default __webpack_public_path__ + "static/media/contactPhone.64999492ae79bf0928b7f1612a48da02.svg";
export { ForwardRef as ReactComponent };